import { Box, ListItem, ListItemText } from '@mui/material'
import type { ReactNode } from 'react'

interface SummarySubItemProps {
  title: string
  subtitle: string
  secondarySlot?: ReactNode
}

const SummarySubItem = (props: SummarySubItemProps) => {
  const { secondarySlot, subtitle, title } = props

  return (
    <ListItem
      disableGutters
      disablePadding
      secondaryAction={
        secondarySlot && (
          <Box sx={{ color: 'text.secondary', '& .MuiTypography-root': { fontSize: '0.875rem' } }}>{secondarySlot}</Box>
        )
      }
    >
      <ListItemText
        primary={title}
        secondary={subtitle}
        primaryTypographyProps={{ variant: 'body2' }}
        secondaryTypographyProps={{ variant: 'caption' }}
      />
    </ListItem>
  )
}

export default SummarySubItem
